//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum NotifyAppointmentMode {
	OnlyEMail = 0,
	AttachICalendar = 1,
	AttachVCard = 2,
	AttachICalendarAndVCard = 3
}
